<template>
  <div class="top-bar-area bg-white">
    <div class="barraMenu container" style="padding:0;">
      <div class="row">
        <div>
          <nav class="nav main-menu">
            <div id="menu" class="menu">
              <a href="https://www.lefisc.com.br/" class="linhaDivisoria">
                <img class="imagem" src="https://www.lefisc.com.br/difal/static/img/logo.png" alt>
              </a>
              <router-link :to="{name: 'home'}" class="links">{{nomeProduto}}</router-link>
            </div>
          </nav>
        </div>
        <div class="col-md-2">
          <div class="social-links social-links-2 text-rights f-right">
            <ul class="navbar-nav justify-content-end navbar-nav-right demo-navbar-messages">
              <li class="nav-item dropdown d-xl-inline-block acc-setting">
              </li>
            </ul>
          </div>
        </div>
         
      </div>
      <div class="testemenu"><linkMenu v-for="item in menuProduto" :key="item.id" :item="item"></linkMenu>
        </div>
    </div>
    
  </div>
</template>
<script>
import linkMenu from "./linkMenu.vue";
import serviceRegulamentos from "../../services/serviceRegulamentos.js";
export default {
  components: {
    linkMenu: linkMenu
  },
  async created() {
    this.nomeProduto = await serviceRegulamentos.getProduto("3");
    this.menuProduto = await serviceRegulamentos.getMenuApoio("3");
  },
  data() {
    return {
      nomeProduto: null,
      menuCollapsed: false,
      showMenu: false,
      menuProduto: null
      // menuOriginal:[{nome:'Regulamento', endereco:'teste'},{nome:'Home', endereco:'teste'},{nome:'Anexos', endereco:'teste'},{nome:'Apêndices RICMS', endereco:'teste'},{nome:'Principais Normas', endereco:'teste'},{nome:'A-Z Índice alfabético', endereco:'teste'}],
    };
  }
};
</script>
<style scoped>

.menumob {
  position: absolute;
  right: 0;
}

@media (min-width: 992px) {
  .titulo {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: black;
    padding-left: 0px !important;
    margin-right: 0px;
  }
  .botaoNovaEmpresa {
    width: 10em !important;
    margin-right: 1em;
  }
}


@media (max-width: 0px) {
  .titulo {
    padding: 0em !important;
    font-size: 20px !important;
  }
  .imagemMobile {
    position: absolute;
    width: 103px;
    height: 25px;
  }
  .iconeMenu {
    float: right;
    font-size: 1.8em;
    position: relative;
    color: #333333;
  }
  .mobile {
    display: inline !important;
  }
  .menuItens {
    background-color: #fff;
    padding-left: 20% !important;
  }
  .menuItens a {
    padding-top: 2em !important;
    padding-bottom: 2em !important;
    width: 100%;
    border-bottom: #333333 1px solid;
  }
  .menuItens a:hover,
  .menuItens a:focus {
    background-color: #bfbfbf;
    color: #fff !important;
  }
  .barraMenu {
    display: none;
  }
  .notificacao {
    position: relative;
    left: 0.2em !important;
    top: -0.7em;
  }
}
#menu .links:nth-child(2) {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #000;
  text-decoration: none;
  transition: 1s;
}

#menu .links:nth-child(2):hover {
  color: #0876b6;
}

.mobile {
  display: none;
}
.notificacao {
  position: relative;
  left: -0.4em;
  top: -0.7em;
}
.titulo {
  font-size: 20px;
  font-weight: 600;
  color: black;
  padding-left: 10px;
  position: fixed !important;
}
.panel-heading {
  padding-right: 0 !important;
}
.botaoNovaEmpresa {
  width: 12em;
}
.imagem {
  width: 103px;
  height: 25px;
}
.barraMenu {
  height: 55px;
  position: relative;
}
.teste {
  position: relative;
  bottom: 0.7em;
}
.main-menu {
  position: relative;
}

.main-menu div {
  display: inline-block;
  line-height: 1;
  position: relative;
  padding-top: 10px;
}

.main-menu div a {
  color: black;
  font-size: 13px;
  line-height: 1;
  padding: 0.5em;
  display: inline-block;
  text-transform: capitalize;
  position: relative;
  vertical-align: middle;
}

.main-menu a:hover {
  color: #0876b6;
}
.main-menu a:focus {
  color: #0876b6;
}

.linhaDivisoria::after {
  content: "";
  position: absolute;
  background: gray;
  height: 22px;
  width: 1px;
  left: 9.68em;
  top: 50%;
  transform: translateY(-50%);
}
.links {
  margin: 0 0.3em;
}

.top-bar-area {
  height: 65px;
}

.container {
  max-width: 1168px;
}

.testemenu {

  position: absolute;
  top: 16.5px;
  right: 0px;
}

</style>


// WEBPACK FOOTER //
// src/shared/menuTopo/menuTopo.vue